import React, { useMemo } from 'react';

import './PageHeader.sass';

import { usePageContext } from './usePageContext';

export type PageHeaderSize = 'medium' | 'large';
export interface PageHeaderCtx {
  size: PageHeaderSize;
}

export interface PageHeaderProps extends React.PropsWithChildren {
  title: string | React.ReactNode;
  breadcrumbs?: React.ReactNode;
  tag?: React.ReactNode;
  actions?: React.ReactNode;
}

function PageHeader({
  title,
  breadcrumbs = undefined,
  tag = undefined,
  actions = undefined,
  children = undefined,
}: PageHeaderProps): JSX.Element {
  const { getTitleComponent } = usePageContext();

  const TitleComponent = useMemo((): React.ReactNode => {
    switch (typeof title) {
      case 'string': return getTitleComponent(title);
      default: return title;
    }
  }, [title, getTitleComponent]);

  return (
    <div className="PageHeaderV2">

      {!!breadcrumbs && (
        <div>
          {breadcrumbs}
        </div>
      )}

      <div className="PageHeaderV2__Inner">
        <div className="PageHeaderV2__Content">
          <div className="PageHeaderV2__NameContainer">
            {TitleComponent}
            {tag}
          </div>
          {children}
        </div>

        {!!actions && (
          <div className="PageHeaderV2__Actions">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}

export { PageHeader };
